var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.enhancedComponents),function(component,i){return _c(_vm.getComponentToRender(component.type),_vm._g(_vm._b({key:i,tag:"component"},'component',_vm.getBindingData(component),false),_vm.getEventHandlers(component.type)))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }